import { render } from "./TvmTransportTypes.vue?vue&type=template&id=002965c4&scoped=true"
import script from "./TvmTransportTypes.js?vue&type=script&lang=js&external"
export * from "./TvmTransportTypes.js?vue&type=script&lang=js&external"

import "./TvmTransportTypes.vue?vue&type=style&index=0&id=002965c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002965c4"],['__file',"src/components/ChatWidget/TvmTransportTypes/TvmTransportTypes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "002965c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('002965c4', __exports__)) {
    api.reload('002965c4', __exports__)
  }
  
  module.hot.accept("./TvmTransportTypes.vue?vue&type=template&id=002965c4&scoped=true", () => {
    api.rerender('002965c4', render)
  })

}


export default __exports__